import type { CardDetails } from '@/types/adyen';
import { useRef } from 'react';

export const useInitilizeAdyen = () => {
  const adyenCardDetailsRef = useRef<CardDetails>({} as CardDetails);

  return {
    adyenCardDetailsRef,
  };
};
